import React, {Component} from 'react';
import '../assets/teachers.css';
import {connect} from "react-redux";
import {Modal, Tabs, Tab} from "react-bootstrap";
import closeModalIcon from '../assets/images/ico-close.png';
import warningIcon from '../assets/images/ico-warning.png';
import startButton from '../assets/images/startButton.png';
import videoInstructionFull from '../assets/images/videoInstructionFull.png';
import playVideo from '../assets/images/playVideo.png';
import stopRecording from '../assets/images/stopButton.png';
import redoRecording from '../assets/images/redoButton.png';
import exitApp from '../assets/images/finishBtn.png';
import recordAudio from '../assets/images/recordAudio.png';
import recordVideo from '../assets/images/recordVideo.png';
import recordBtn from '../assets/images/recordBtn1.png';
import beginBtn from '../assets/images/beginBtn.png';
import changeBtn from '../assets/images/changeBtn.png';
import saveBtn from '../assets/images/saveBtn.png';
import readInstructions from '../assets/images/read_instructions.png';
import signSayInstructions from '../assets/images/sign_say_instructions.png';
import countdownInstructions from '../assets/images/countdown_instructions.png';
import signInstructions from '../assets/images/sign_instructions.png';
import rotateInstruction from '../assets/images/rotate_device_fff_bg.png';
import whiteboard from '../assets/images/wordMark2/Whiteboard.png';
import {withRouter} from "react-router-dom";
import {CountDownComponent} from "../StudentsComponent/Common";
import {clearInterval, setInterval} from "timers";
import App_Selection_Graphic from "../assets/images/App_Selection_Graphic.png";
let contentModal = '';

const InstructionModals = class DialogBoxComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: this.props.modalOpen ? this.props.modalOpen : false
        }

        this.closeModal = this.closeModal.bind(this);
        this.instructionToggle = this.instructionToggle.bind(this);
    }

    componentDidMount() {
    }

    openModal() {
        this.setState({ isModalOpen: true });
    }

    instructionToggle(event){
        this.props.toggleInstruction(event.target.checked);
    }

    closeModal(){
        this.props.closeClick(false);
        this.setState({ isModalOpen: false });
    }

    render() {

        return (
            <Modal id="InstructionBox" show={this.props.modalOpen}>
                <div className="modal-content">
                    <div className={"row modal-body"} >
                            {/*<span style={{cursor: "pointer"}} onClick={this.closeModal}><img*/}
                                {/*style={{width: 50, marginTop: 25, float: 'right'}} src={closeModalIcon}/></span>*/}
                        <div className="section">
                            { this.props.WordMark ?
                                <h4 style={{marginBottom:25,fontSize:25}}>You have 3 minutes to write a story. Your work will be saved automatically.</h4>
                                :
                                <h1 style={{marginBottom:25,fontSize:35}}>How to Play</h1>
                            }
                                {this.props.Slash ?
                                    <SlashInstruction instructionMask={rotateInstruction} />
                                    :
                                    null
                                }
                                { this.props.PN ?
                                    <PNInstruction instructionMask={videoInstructionFull} startButton={startButton} />
                                :
                                    null
                                }
                                { this.props.WSS ?
                                    <WSSInstruction instructionMask={videoInstructionFull} startButton={startButton} />
                                    :
                                    null
                                }
                                { this.props.Copyright ?
                                    <CopyrightInstruction instructionMask={videoInstructionFull} startButton={startButton} />
                                    :
                                    null
                                }
                                { this.props.Kidspeak ?
                                    <KidspeakInstruction instructionMask={videoInstructionFull} startButton={startButton} />
                                    :
                                    null
                                }
                                { this.props.KidSign ?
                                    <KidSignInstruction instructionMask={videoInstructionFull} startButton={startButton} />
                                    :
                                    null
                                }
                            { this.props.WordMark ?
                                <WordmarkInstruction buttonClick={this.props.buttonClick} beginClick={this.props.beginClick} changeClick={this.props.changeClick} time={this.props.time} sessionTime={this.props.sessionTime} starterTitle={this.props.starterTitle} instructionMask={videoInstructionFull} startButton={startButton} />
                                :
                                null
                            }
                        <div className={"col-md-12"}>
                                {this.props.WordMark?
                                    null
                                    :
                                    <div>
                                        <div className={"col-md-2 col-xs-3"}>
                                            { this.props.Slash ? null :
                                                <label htmlFor="instructionToggle" className="cb"
                                                       style={{paddingTop: 7}}>
                                                    <input type="checkbox" onChange={this.instructionToggle}
                                                           id="instructionToggle"/><span className="checkmark"
                                                                                         style={{top: 5}}></span> Hide
                                                </label>
                                            }
                                        </div>
                                        <div className={"col-md-10 col-xs-9"}>
                                        <a onClick={this.closeModal} className="handBtn pull-right">
                                            <span>Close</span>
                                        </a>
                                        </div>
                                    </div>
                                }
                        </div>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
};

class SlashInstruction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key:1
        }
        this.handleSelect = this.handleSelect.bind(this);
    }
    handleSelect(key){
        this.setState({key: key});
    }
    render() {
        return (
            <div className={"col-md-12"} style={{textAlign:'left'}}>
                        <img src={this.props.instructionMask} style={{width:'100%'}}/>
            </div>
        )
    }
}

class PNInstruction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key:1
        }

        this.handleSelect = this.handleSelect.bind(this);
    }
    handleSelect(key){
        this.setState({key: key});
    }
    render() {
        return (
            <div className={"col-md-12"} style={{textAlign:'left'}}>
                <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="copyrightTab">
                    <Tab eventKey={1} >
                        <p><div className={"circleBtn greenBtn"}>1</div></p>
                        <img src={this.props.instructionMask} style={{width:'100%'}}/>
                    </Tab>
                    <Tab eventKey={2}>
                        <p><div className={"circleBtn greenBtn"}>2</div> <img src={this.props.startButton} style={{marginLeft:35,width:75}} /></p>
                        <img src={countdownInstructions} style={{width:200}} />
                        <br/>
                        <p><div className={"circleBtn greenBtn"}>3</div></p>
                        <img src={signInstructions} style={{width:200}} />
                    </Tab>
                </Tabs>
                <div style={{position:'absolute',left:0,bottom:0, margin:'auto', width:'100%'}}>
                    <div className={"center-block text-center"}>
                        {
                            this.state.key === 1 ?
                                <a className={"handBtn handBtn active"} onClick={()=>this.handleSelect(2)}><span>Next</span></a>
                                :
                                <a className={"handBtn handBtn active"} onClick={()=>this.handleSelect(1)}><span>Back</span></a>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

class WSSInstruction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key:1
        }
        this.handleSelect = this.handleSelect.bind(this);
    }
    handleSelect(key){
        this.setState({key: key});
    }
    render() {
        return (
            <div className={"col-md-12"} style={{textAlign:'left'}}>
                <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="copyrightTab">
                    <Tab eventKey={1} >
                            <p><div className={"circleBtn greenBtn"}>1</div></p>
                            <img src={this.props.instructionMask} style={{width:'100%'}}/>
                    </Tab>
                    <Tab eventKey={2}>
                            <p><div className={"circleBtn greenBtn"}>2</div> <img src={this.props.startButton} style={{marginLeft:35,width:75}} /></p>
                            <img src={countdownInstructions} style={{width:200}} />
                            <br/>
                            <p><div className={"circleBtn greenBtn"}>3</div></p>
                            <img src={signSayInstructions} style={{width:200}} />
                    </Tab>
                </Tabs>
                <div style={{position:'absolute',left:0,bottom:0, margin:'auto', width:'100%'}}>
                    <div className={"center-block text-center"}>
                        {
                            this.state.key === 1 ?
                                <a className={"handBtn handBtn active"} onClick={()=>this.handleSelect(2)}><span>Next</span></a>
                                :
                                <a className={"handBtn handBtn active"} onClick={()=>this.handleSelect(1)}><span>Back</span></a>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

class CopyrightInstruction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key:1
        }

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(key){
        this.setState({key: key});
    }

    render() {
        return (
            <div className={"col-md-12"} style={{textAlign:'left'}}>
                <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="copyrightTab">
                    <Tab eventKey={1} >
                        <p><div className={"circleBtn greenBtn"}>1</div></p>
                        <img src={this.props.instructionMask} style={{width:'100%'}}/>
                    </Tab>
                    <Tab eventKey={2}>
                        <p><div className={"circleBtn greenBtn"}>2</div> <img src={playVideo} style={{marginLeft:35,height:35}} /></p>
                        <br/>
                        <p><div className={"circleBtn greenBtn"}>3</div> <img src={this.props.instructionMask} style={{width:'250px'}}/> <img src={this.props.startButton} style={{height:35}} /></p>
                        <p><div className={"circleBtn greenBtn"}>4</div> <img src={countdownInstructions} style={{width:200}} /> </p>
                        <p><div className={"circleBtn greenBtn"}>5</div> <img src={exitApp} style={{marginLeft:35,height:35}} /></p>
                    </Tab>
                </Tabs>
                <div style={{position:'absolute',left:0,bottom:0, margin:'auto', width:'100%'}}>
                    <div className={"center-block text-center"}>
                        {
                            this.state.key === 1 ?
                                <a className={"handBtn handBtn active"} onClick={()=>this.handleSelect(2)}><span>Next</span></a>
                                :
                                <a className={"handBtn handBtn active"} onClick={()=>this.handleSelect(1)}><span>Back</span></a>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

class KidspeakInstruction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key:1
        }

        this.handleSelect = this.handleSelect.bind(this);
    }
    handleSelect(key){
        this.setState({key: key});
    }
    render() {
        return (
            <div className={"col-md-12"} style={{textAlign:'left'}}>
                <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="copyrightTab">
                    <Tab eventKey={1} >
                        <p><div className={"circleBtn greenBtn"}>1</div> Read the title of the passage.</p>
                        <br/>
                        <p><div className={"circleBtn greenBtn"}>2</div> <img src={recordBtn} style={{marginLeft:35,height:35}} /></p>
                        <p><div className={"circleBtn greenBtn"}>3</div> <img src={countdownInstructions} style={{width:200}} /></p>
                        <p><div className={"circleBtn greenBtn"}>4</div> <img src={exitApp} style={{marginLeft:35,height:35}} /></p>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

class KidSignInstruction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key:1
        }

        this.handleSelect = this.handleSelect.bind(this);
    }
    handleSelect(key){
        this.setState({key: key});
    }
    render() {
        return (
            <div className={"col-md-12"} style={{textAlign:'left'}}>
                <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="copyrightTab">
                    <Tab eventKey={1} >
                        <p><div className={"circleBtn greenBtn"}>1</div>  <img src={readInstructions} style={{width:250}} /></p>
                        <p><div className={"circleBtn greenBtn"}>2</div>  <img src={signInstructions} style={{width:200}} /></p>
                        <p><div className={"circleBtn greenBtn"}>3</div>  <img src={recordVideo} style={{marginLeft:35,height:35}} /> </p>
                    </Tab>
                    <Tab eventKey={2} >
                        <p><div className={"circleBtn greenBtn"}>4</div> <img src={countdownInstructions} style={{width:200}} /></p>
                        <p><div className={"circleBtn greenBtn"}>5</div> <img src={signInstructions} style={{width:200}} /></p>
                        <p><div className={"circleBtn greenBtn"}>6</div> <img src={stopRecording} style={{marginLeft:35,height:35}} /></p>
                        <p><div className={"circleBtn greenBtn"}>7</div> <img src={exitApp} style={{marginLeft:35,height:35}} /></p>
                    </Tab>
                </Tabs>
                <div style={{position:'absolute',left:0,bottom:0, margin:'auto', width:'100%'}}>
                    <div className={"center-block text-center"}>
                        {
                            this.state.key === 1 ?
                                <a className={"handBtn handBtn active"} onClick={()=>this.handleSelect(2)}><span>Next</span></a>
                                :
                                <a className={"handBtn handBtn active"} onClick={()=>this.handleSelect(1)}><span>Back</span></a>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

class WordmarkInstruction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key:1
        }

        this.handleSelect = this.handleSelect.bind(this);
        this.beginStory = this.beginStory.bind(this);
        this.changeStory = this.changeStory.bind(this);
        this.handleBack = this.handleBack.bind(this);
    }
    handleSelect(key){
        this.setState({key: key});
    }
    beginStory(){
        this.props.beginClick(true);
    }
    changeStory(){
        this.props.changeClick(true);
    }
    handleBack(){
        this.props.buttonClick(0);
    }
    render() {
        return (
            <div className={"col-md-12"} style={{textAlign:'left'}}>
                <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="wordmarkTab">
                    <Tab eventKey={1} >
                        <p>Your Story: <br/><b>"{this.props.starterTitle}"</b></p>
                        <CountDownComponent time={this.props.time} sessionTime={this.props.sessionTime} showTime={10}/>
                        <div className={"col-md-12"} style={{position:'relative',display:'inline-block'}}>
                            <a onClick={this.changeStory} className="handBtn" style={{marginRight:15}}>
                                <span>Change</span>
                            </a>
                            <a onClick={this.beginStory} className="handBtn">
                                <span>Begin</span>
                            </a>
                        </div>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}




const bindActionToProps = dispatch => {
    return {
    };
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, bindActionToProps)(InstructionModals)



// WEBPACK FOOTER //
// ./src/Shared/InstructionModals.js